import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgRotate = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M19.95 11a8 8 0 1 0 -.5 4m.5 5v-5h-5" })
});
export { SvgRotate as ReactComponent };
